export enum ListingStatus {
  created = 'created',
  active = 'active',
  inactive = 'inactive',
  expired = 'expired',
}

export const ListingStatusValues: { [key in ListingStatus]: string } = {
  created: 'Created',
  active: 'Active',
  inactive: 'Inactive',
  expired: 'Expired',
};
